import * as React from "react"
import colors from "@digits-shared/themes/colors"
import { m } from "framer-motion"
import styled from "styled-components"

const ContentContainer = styled.div`
  width: 390px;
  .mobile & {
    width: calc(100vw - 32px);
    max-width: 390px;
  }

  align-self: center;
  background: ${colors.translucentWhite30};
  background-blend-mode: luminosity;
  padding: 16px;
  border-radius: 24px;
  border: 1px solid ${colors.white};
  position: relative;
  display: flex;
  flex-direction: column;
  box-shadow: 0px 8px 50px 0px rgba(50, 73, 127, 0.25);
`

export const BiscuitContent = styled.div`
  background: ${colors.translucentWhite70};
  border-radius: 16px;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex-grow: 1;
`

export const Biscuit: React.FC<React.PropsWithChildren<{ className?: string }>> = ({
  children,
  className,
}) => (
  <ContentContainer className={className}>
    <BiscuitContent>{children}</BiscuitContent>
  </ContentContainer>
)

export const AnimatedWrapper = styled(m.div)`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  width: 100%;
`
